import encryption from "./encryption.js";

export default async function RSA(str) {
  return encryption.encryptedReqstr(str);
}
